import { Padding } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";

const MobileTopBar = ({ children, onBack, showBack }) => {
  return (
    <Box
      style={{
        position: "sticky",
        top: 0,
        left: 0,
        width: "100%",
        height: "50px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        paddingTop: "5px",
        backgroundColor: "#181A20",
      }}
      zIndex={1000}
    >
      {showBack && (
        <IconButton
          style={{
            position: "absolute",
            left: "10px",
            top: "5px",
            height: "50px",
          }}
          onClick={onBack}
        >
          <ArrowBackIcon style={{ color: "white" }} />
        </IconButton>
      )}

      <Typography
        style={{
          borderRadius: "10px",
          fontSize: "24px",
          fontFamily: "Urbanist",
          fontWeight: "600",
          color: "rgba(255, 255, 255, 1)",
          padding: "7.5px 60px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",
          width: "auto",
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default MobileTopBar;
